import { Form, Select } from "antd";
import React from "react";
import { Controller } from "react-hook-form";

function Dropdown1({
  control,
  errors,
  isMulti,
  label,
  onChange,
  className,
  name,
  disabled,
  required,
  placeholder,
  options = [],
  allowonly,
  data_tour,
  readOnly = false,
  selectAll = false, // <-- new prop to enable Select All
}) {
  const SELECT_ALL_KEY = "SELECT_ALL";

  const dropdownOptions = options;

  const isAllSelected = (selectedValues) => {
    if (!selectedValues || !dropdownOptions.length) return false;
    return dropdownOptions.length === selectedValues.length;
  };

  const handleSelectAll = (selected) => {
    if (!selectAll) return selected;

    const selectedWithoutAll = selected.filter((val) => val !== SELECT_ALL_KEY);
    const allOptionsSelected = isAllSelected(selectedWithoutAll);

    if (selected.includes(SELECT_ALL_KEY)) {
      return allOptionsSelected ? [] : dropdownOptions.map((opt) => opt.value);
    }

    return selected;
  };

  return (
    <Form.Item
      name={name}
      validateStatus={errors && Object.keys(errors)?.length ? "error" : ""}
      className={`${className} d-block`}
    >
      <div>{label}</div>
      <Controller
        name={name}
        rules={required}
        control={control}
        render={({ field }) => (
          <Select
            data-tour={data_tour}
            showSearch
            allowClear
            dropdownStyle={{ minWidth: "30rem" }}
            open={readOnly ? false : undefined}
            value={field.value || (isMulti ? [] : null)}
            disabled={disabled}
            placeholder={placeholder}
            style={{ width: "100%" }}
            mode={isMulti ? "multiple" : ""}
            onChange={(value) => {
              let finalValues = value;

              // Apply Select All logic if enabled and in multi-select mode
              if (selectAll && isMulti && Array.isArray(value)) {
                finalValues = handleSelectAll(value);
              }

              // Limit the number of selections if allowonly is defined
              if (allowonly && finalValues.length > allowonly) {
                finalValues = finalValues.slice(0, allowonly);
              }

              field.onChange(finalValues);
              if (onChange) onChange(finalValues);
            }}
            filterOption={(input, option) =>
              (option?.label?.toLowerCase() ?? "").includes(
                input.toLowerCase()
              ) ||
              (option?.value?.toString().toLowerCase() ?? "").includes(
                input.toLowerCase()
              )
            }
            // filterSort={(optionA, optionB) =>
            //   (optionA?.label ?? "")
            //     .toLowerCase()
            //     .localeCompare((optionB?.label ?? "")?.toLowerCase())
            // }
            dropdownRender={(menu) => (
              <>
                {selectAll && isMulti && (
                  <div
                    style={{
                      padding: "8px",
                      cursor: "pointer",
                      backgroundColor: "#f0f0f0",
                      borderBottom: "1px solid #d9d9d9",
                    }}
                    onClick={() => {
                      const allValues = dropdownOptions.map((opt) => opt.value);
                      const currentValues = field.value || [];
                      const newValues = isAllSelected(currentValues)
                        ? []
                        : allValues;
                      field.onChange(newValues);
                      if (onChange) onChange(newValues);
                    }}
                  >
                    <span style={{ marginRight: 8 }}>
                      {isAllSelected(field.value) ? "✓" : ""}
                    </span>
                    Select All
                  </div>
                )}
                {menu}
              </>
            )}
          >
            {dropdownOptions.map((x, id) => (
              <Select.Option key={id} value={x?.value} label={x?.label}>
                {x?.label}
              </Select.Option>
            ))}
          </Select>
        )}
      />
    </Form.Item>
  );
}

export default Dropdown1;
